// extracted by mini-css-extract-plugin
module.exports = {"tag":"p5_ic","blue":"p5_p6","red":"p5_p7","green":"p5_p8"};